import { getSessionStorage } from '@/utils'
import { LOCAL_KEY_USER_NAME, LOCAL_KEY_USER_CODE, LOCAL_KEY_PART_NO, LOCAL_KEY_CSH_PIKER, LOCAL_KEY_ORDER_STATUS, LOCAL_KEY_ORDER_STATUS_INDEX, LOCAL_KEY_USERTYPE, LOCAL_KEY_USERTYPE_INDEX, LOCAL_KEY_SHOW_PERSONAL, LOCAL_KEY_SEARCH_CONTENT } from '@/config'
const state = {
  userName: getSessionStorage(LOCAL_KEY_USER_NAME)
    ? getSessionStorage(LOCAL_KEY_USER_NAME)
    : '',
  userCode: getSessionStorage(LOCAL_KEY_USER_CODE)
    ? getSessionStorage(LOCAL_KEY_USER_CODE)
    : '',
  partNo: getSessionStorage(LOCAL_KEY_PART_NO)
    ? getSessionStorage(LOCAL_KEY_PART_NO)
    : '',
  cshPicker: getSessionStorage(LOCAL_KEY_CSH_PIKER)
    ? getSessionStorage(LOCAL_KEY_CSH_PIKER)
    : '',
  orderStatusList: getSessionStorage(LOCAL_KEY_ORDER_STATUS)
    ? getSessionStorage(LOCAL_KEY_ORDER_STATUS)
    : '',
  name: getSessionStorage(LOCAL_KEY_ORDER_STATUS_INDEX)
    ? getSessionStorage(LOCAL_KEY_ORDER_STATUS_INDEX)
    : '',
  userType: getSessionStorage(LOCAL_KEY_USERTYPE)
    ? getSessionStorage(LOCAL_KEY_USERTYPE)
    : '',
  userTypeIndex: getSessionStorage(LOCAL_KEY_USERTYPE_INDEX)
    ? getSessionStorage(LOCAL_KEY_USERTYPE_INDEX)
    : '',
  showPersonalFlg: getSessionStorage(LOCAL_KEY_SHOW_PERSONAL)
    ? getSessionStorage(LOCAL_KEY_SHOW_PERSONAL)
    : '',
  searchContent: getSessionStorage(LOCAL_KEY_SEARCH_CONTENT)
    ? getSessionStorage(LOCAL_KEY_SEARCH_CONTENT)
    : ''
}
export default state
